import { uploadData } from "aws-amplify/storage";
import {
  checkIfFileExists,
  convertFontToWoff2,
  convertImageToWebP,
} from "./assetConversionUtils";

export const uploadFileToS3 = async (
  Key: string,
  data: { stringData?: string; file?: File },
  type?: string,
  progressCallback?: (progress: { loaded: number; total: number }) => void
) => {
  const { stringData, file } = data;

  const convertFunctions: {
    [key: string]: (params: any) => Promise<{
      key: any;
    }>;
    "image/png": typeof convertImageToWebP;
    "image/jpeg": typeof convertImageToWebP;
    "image/jpg": typeof convertImageToWebP;
    "font/ttf": typeof convertFontToWoff2;
    "font/otf": typeof convertFontToWoff2;
  } = {
    "image/png": convertImageToWebP,
    "image/jpeg": convertImageToWebP,
    "image/jpg": convertImageToWebP,
    "font/ttf": convertFontToWoff2,
    "font/otf": convertFontToWoff2,
  };
  const condition = !(await checkIfFileExists(Key))
  if (condition) {
    const formatsToUploadFiles = ["audio", "video", "image", "font"]; // the rest are uploaded as strings
    const data = formatsToUploadFiles.some((format) => type?.includes(format))
      ? file
      : (stringData || file);
    if (data) {
      await uploadData({
        key: Key,
        data,
        options: {
          accessLevel: "guest",
          contentType: type || "application/json",
          onProgress(event) {
            progressCallback &&
              progressCallback({
                loaded: event.transferredBytes,
                total: event.totalBytes || 100,
              });
          },
        },
      }).result;
    }
  }
  try {
    if (type && convertFunctions[type]) {
      return await convertFunctions[type]({
        key: Key,
      });
    }
  } catch (e) {
    console.log("failed to convert. Using fallback", e);
  }
  return { key: Key };
};
